/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: wx3bEfvj7g

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import DirectoryUserRow from "../../components/app-auth/DirectoryUserRow"; // plasmic-import: _c0HP8vrOTq/component
import GroupItem from "../../components/app-auth/GroupItem"; // plasmic-import: rF43GtStPO/component
import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicDirectoryConfig.module.css"; // plasmic-import: wx3bEfvj7g/css

import GearIcon from "../plasmic_kit/PlasmicIcon__Gear"; // plasmic-import: ZmVZmXEc9f_SR/icon
import ArrowLeftSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowLeftSvg"; // plasmic-import: -d8Kjj4sp/icon
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import CloseSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CloseSvg"; // plasmic-import: DhvEHyCHT/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon
import UsersSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__UsersSvg"; // plasmic-import: SQUWUgO0N/icon

createPlasmicElementProxy;

export type PlasmicDirectoryConfig__VariantMembers = {};
export type PlasmicDirectoryConfig__VariantsArgs = {};
type VariantPropType = keyof PlasmicDirectoryConfig__VariantsArgs;
export const PlasmicDirectoryConfig__VariantProps =
  new Array<VariantPropType>();

export type PlasmicDirectoryConfig__ArgsType = { selected?: string };
type ArgPropType = keyof PlasmicDirectoryConfig__ArgsType;
export const PlasmicDirectoryConfig__ArgProps = new Array<ArgPropType>(
  "selected"
);

export type PlasmicDirectoryConfig__OverridesType = {
  root?: Flex__<"div">;
  directoryName?: Flex__<"div">;
  backBtn?: Flex__<typeof Button>;
  gearIcon?: Flex__<typeof IconButton>;
  closeIcon?: Flex__<typeof IconButton>;
  groupsLabel?: Flex__<"div">;
  groupsList?: Flex__<"div">;
  addGroupBtn?: Flex__<typeof IconButton>;
  addUserBtn?: Flex__<typeof IconButton>;
  directoryUsers?: Flex__<"div">;
  importFromBtn?: Flex__<typeof Button>;
  uploadCsvBtn?: Flex__<typeof Button>;
};

export interface DefaultDirectoryConfigProps {
  selected?: string;
  className?: string;
}

const $$ = {};

function PlasmicDirectoryConfig__RenderFunc(props: {
  variants: PlasmicDirectoryConfig__VariantsArgs;
  args: PlasmicDirectoryConfig__ArgsType;
  overrides: PlasmicDirectoryConfig__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          selected: "permissions",
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__aPkY1)}>
        <div className={classNames("all", sty.freeBox__pAaNl)}>
          <div className={classNames("all", sty.freeBox__a8N8Y)}>
            <UsersSvgIcon
              className={classNames("all", sty.svg__xWqqk)}
              role={"img"}
            />
          </div>
          <div className={classNames("all", sty.freeBox__xzqUp)}>
            <div className={classNames("all", sty.freeBox__yjXtP)}>
              <div
                data-plasmic-name={"directoryName"}
                data-plasmic-override={overrides.directoryName}
                className={classNames("all", "__wab_text", sty.directoryName)}
              >
                {"Main users"}
              </div>
              <div className={classNames("all", "__wab_text", sty.text__fzVhc)}>
                {"Directory"}
              </div>
            </div>
            <Button
              data-plasmic-name={"backBtn"}
              data-plasmic-override={overrides.backBtn}
              className={classNames("__wab_instance", sty.backBtn)}
              endIcon={
                <ChevronDownSvgIcon
                  className={classNames("all", sty.svg__lMtRk)}
                  role={"img"}
                />
              }
              startIcon={
                <ArrowLeftSvgIcon
                  className={classNames("all", sty.svg___3KoJa)}
                  role={"img"}
                />
              }
              type={["clear"]}
              withIcons={["startIcon"]}
            >
              <div className={classNames("all", "__wab_text", sty.text__qKaok)}>
                {"Back"}
              </div>
            </Button>
            <IconButton
              data-plasmic-name={"gearIcon"}
              data-plasmic-override={overrides.gearIcon}
              children2={
                <ChevronDownSvgIcon
                  className={classNames("all", sty.svg__f8Xzc)}
                  role={"img"}
                />
              }
              className={classNames("__wab_instance", sty.gearIcon)}
            >
              <GearIcon
                className={classNames("all", sty.svg___8ANhE)}
                role={"img"}
              />
            </IconButton>
            <IconButton
              data-plasmic-name={"closeIcon"}
              data-plasmic-override={overrides.closeIcon}
              children2={
                <ChevronDownSvgIcon
                  className={classNames("all", sty.svg__rMqOv)}
                  role={"img"}
                />
              }
              className={classNames("__wab_instance", sty.closeIcon)}
            >
              <CloseSvgIcon
                className={classNames("all", sty.svg__kddJ9)}
                role={"img"}
              />
            </IconButton>
          </div>
        </div>
      </div>
      <div className={classNames("all", sty.freeBox__nqev0)}>
        <div className={classNames("all", sty.columns__vM8D)}>
          <div className={classNames("all", sty.column__m8Fe)}>
            <div
              data-plasmic-name={"groupsLabel"}
              data-plasmic-override={overrides.groupsLabel}
              className={classNames("all", "__wab_text", sty.groupsLabel)}
            >
              {"Groups"}
            </div>
          </div>
          <div
            data-plasmic-name={"groupsList"}
            data-plasmic-override={overrides.groupsList}
            className={classNames("all", sty.groupsList)}
          >
            <GroupItem
              className={classNames("__wab_instance", sty.groupItem__oqv16)}
              group={
                <div
                  className={classNames("all", "__wab_text", sty.text__qQuGf)}
                >
                  {"mgmt"}
                </div>
              }
            />

            <GroupItem
              className={classNames("__wab_instance", sty.groupItem__yNoEv)}
              group={"dev"}
            />

            <GroupItem
              className={classNames("__wab_instance", sty.groupItem__hRmkw)}
              group={"ops"}
              withoutBorder={true}
            />
          </div>
          <div className={classNames("all", sty.column__fDzpJ)}>
            <IconButton
              data-plasmic-name={"addGroupBtn"}
              data-plasmic-override={overrides.addGroupBtn}
              children2={
                <ChevronDownSvgIcon
                  className={classNames("all", sty.svg___8CaSi)}
                  role={"img"}
                />
              }
              className={classNames("__wab_instance", sty.addGroupBtn)}
            >
              <PlusSvgIcon
                className={classNames("all", sty.svg___5HCdy)}
                role={"img"}
              />
            </IconButton>
          </div>
        </div>
        <div className={classNames("all", sty.columns__dfy35)}>
          <div className={classNames("all", sty.column__f6Uis)}>
            <div className={classNames("all", "__wab_text", sty.text__x4J25)}>
              {"Users"}
            </div>
          </div>
          <div className={classNames("all", sty.column___2OR5)}>
            <div className={classNames("all", sty.freeBox__ixFOn)}>
              <div className={classNames("all", "__wab_text", sty.text__kYzzB)}>
                {"Group(s)"}
              </div>
              <IconButton
                data-plasmic-name={"addUserBtn"}
                data-plasmic-override={overrides.addUserBtn}
                children2={
                  <ChevronDownSvgIcon
                    className={classNames("all", sty.svg__ipTRx)}
                    role={"img"}
                  />
                }
                className={classNames("__wab_instance", sty.addUserBtn)}
              >
                <PlusSvgIcon
                  className={classNames("all", sty.svg__dFnT)}
                  role={"img"}
                />
              </IconButton>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"directoryUsers"}
          data-plasmic-override={overrides.directoryUsers}
          className={classNames("all", sty.directoryUsers)}
        >
          <DirectoryUserRow
            className={classNames(
              "__wab_instance",
              sty.directoryUserRow__qxSga
            )}
            userEmail={"user@plasmic.app"}
          />

          <DirectoryUserRow
            className={classNames(
              "__wab_instance",
              sty.directoryUserRow__fBjDj
            )}
          />
        </div>
        <div className={classNames("all", sty.freeBox__xI8F)}>
          <Button
            data-plasmic-name={"importFromBtn"}
            data-plasmic-override={overrides.importFromBtn}
            className={classNames("__wab_instance", sty.importFromBtn)}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__k7KhP)}
                role={"img"}
              />
            }
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__sRb6)}
                role={"img"}
              />
            }
            type={["clear"]}
          >
            {"Import from..."}
          </Button>
          <Button
            data-plasmic-name={"uploadCsvBtn"}
            data-plasmic-override={overrides.uploadCsvBtn}
            className={classNames("__wab_instance", sty.uploadCsvBtn)}
            endIcon={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__k6ZBk)}
                role={"img"}
              />
            }
            startIcon={
              <ArrowRightSvgIcon
                className={classNames("all", sty.svg__hWoV3)}
                role={"img"}
              />
            }
            type={["clear"]}
          >
            {"Upload CSV..."}
          </Button>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "directoryName",
    "backBtn",
    "gearIcon",
    "closeIcon",
    "groupsLabel",
    "groupsList",
    "addGroupBtn",
    "addUserBtn",
    "directoryUsers",
    "importFromBtn",
    "uploadCsvBtn",
  ],
  directoryName: ["directoryName"],
  backBtn: ["backBtn"],
  gearIcon: ["gearIcon"],
  closeIcon: ["closeIcon"],
  groupsLabel: ["groupsLabel"],
  groupsList: ["groupsList"],
  addGroupBtn: ["addGroupBtn"],
  addUserBtn: ["addUserBtn"],
  directoryUsers: ["directoryUsers"],
  importFromBtn: ["importFromBtn"],
  uploadCsvBtn: ["uploadCsvBtn"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  directoryName: "div";
  backBtn: typeof Button;
  gearIcon: typeof IconButton;
  closeIcon: typeof IconButton;
  groupsLabel: "div";
  groupsList: "div";
  addGroupBtn: typeof IconButton;
  addUserBtn: typeof IconButton;
  directoryUsers: "div";
  importFromBtn: typeof Button;
  uploadCsvBtn: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDirectoryConfig__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDirectoryConfig__VariantsArgs;
    args?: PlasmicDirectoryConfig__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDirectoryConfig__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDirectoryConfig__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDirectoryConfig__ArgProps,
          internalVariantPropNames: PlasmicDirectoryConfig__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDirectoryConfig__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDirectoryConfig";
  } else {
    func.displayName = `PlasmicDirectoryConfig.${nodeName}`;
  }
  return func;
}

export const PlasmicDirectoryConfig = Object.assign(
  // Top-level PlasmicDirectoryConfig renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    directoryName: makeNodeComponent("directoryName"),
    backBtn: makeNodeComponent("backBtn"),
    gearIcon: makeNodeComponent("gearIcon"),
    closeIcon: makeNodeComponent("closeIcon"),
    groupsLabel: makeNodeComponent("groupsLabel"),
    groupsList: makeNodeComponent("groupsList"),
    addGroupBtn: makeNodeComponent("addGroupBtn"),
    addUserBtn: makeNodeComponent("addUserBtn"),
    directoryUsers: makeNodeComponent("directoryUsers"),
    importFromBtn: makeNodeComponent("importFromBtn"),
    uploadCsvBtn: makeNodeComponent("uploadCsvBtn"),

    // Metadata about props expected for PlasmicDirectoryConfig
    internalVariantProps: PlasmicDirectoryConfig__VariantProps,
    internalArgProps: PlasmicDirectoryConfig__ArgProps,
  }
);

export default PlasmicDirectoryConfig;
/* prettier-ignore-end */
